export default "어떻게\n왜\n얼마나\n언제\n얼마나 많이\n어디서부터\n~이다\n무엇\n무엇인가요\nWHO\n어디\n어느\n어느 것\n차이점\n누구의\n하다\n했다\n가지다\n~할 수 있다\n~ 할 것이다\n~일 것이다\n~할 수 있었다\n~해야 한다"